import { xBaseTheme } from "@stoneage/XDL/types";

export default {
  color: "currentColor",
  style: "solid",
  width: "1px",
} as xBaseTheme["focus"];
